import { ActivityName } from "../types";

export interface IActivityStepTranslations extends Record<string, string> {
  title: string;
  description: string;
}

export interface IActivityTranslations {
  tutorialStep: IActivityStepTranslations;
  beforeMeasurementStep: IActivityStepTranslations;
}


export const createActivityTranslations = (activityName: ActivityName): IActivityTranslations => {
  return {
    tutorialStep: {
      title: `tutorials.vitalParameters.${activityName}.beforeMeasurement.title`,
      description: `tutorials.vitalParameters.${activityName}.beforeMeasurement.description`
    },
    beforeMeasurementStep: {
      title: `tutorials.vitalParameters.${activityName}.info.title`,
      description: `tutorials.vitalParameters.${activityName}.info.description`,
    }
  };
};

const generateMeasurementActivityTranslations = (): Record<ActivityName, IActivityTranslations> => {
  const translations: Record<ActivityName, IActivityTranslations> = {} as Record<ActivityName, IActivityTranslations>;
  Object.values(ActivityName).forEach((activityName) => {
    translations[activityName] = createActivityTranslations(activityName);
  });

  return translations;
};

export const MEASUREMENT_ACTIVITY_TRANSLATIONS: Record<ActivityName, IActivityTranslations> = generateMeasurementActivityTranslations();

export const getActivityTranslations = (activityName: ActivityName): IActivityTranslations => {
  return MEASUREMENT_ACTIVITY_TRANSLATIONS[activityName] || createActivityTranslations(activityName);
};